
const appPartnersConstants = {
  GET_ALL_APP_PARTNERS_REQUEST: 'GET_ALL_APP_PARTNERS_REQUEST',
  GET_ALL_APP_PARTNERS_SUCCESS: 'GET_ALL_APP_PARTNERS_SUCCESS',
  GET_ALL_APP_PARTNERS_FAILURE: 'GET_ALL_APP_PARTNERS_FAILURE',
};

export default appPartnersConstants;
